<script>

import Swiper from '@/utils/verticalSwiper'
import '@/utils/verticalSwiper.css'
import http from '@/utils/http'
import { mapState } from 'vuex'
import lottie from 'lottie-web'
import animationData from '@/assets/banner-ins.json'

export default {

  data () {
    return {
      banner: [],
      isReverse: false,
      autoplay: false,
      anims: []
    }
  },
  computed: {
    ...mapState(['pn', 'aid', 'pkg', 'uid', 'channel', 'code'])
  },
  mounted () {
    this.checkIsReverse()
    this.$nextTick(() => {
      // 先建轮播：loop 会克隆首尾 slide，克隆完再挂 lottie，避免克隆到静态的 SVG 快照
      this.swiper = new Swiper(this.$refs.bannerRef, {
        isReverse: this.isReverse,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: this.$refs.paginationRef,
          clickable: true
        }
      })
      this.initLottie()
    })
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    // this.requestBannerData()

  },
  beforeUnmount () {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.anims.forEach((anim) => anim.destroy())
    this.anims = []
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  },
  methods: {

    // 页面切到后台时 transitionend 不会触发，Swiper 的 animating 会一直挂着把轮播卡死，回前台时复位
    onVisibilityChange () {
      if (!this.swiper || this.swiper.destroyed) {
        return
      }
      if (document.hidden) {
        this.swiper.autoplay.stop()
      } else {
        this.swiper.animating = false
        this.swiper.autoplay.start()
      }
    },

    // 原始 slide 和 loop 克隆出来的 slide 各挂一个实例，克隆页才不会是空白
    initLottie () {
      const containers = this.$refs.bannerRef.querySelectorAll('.lottie-slide')
      this.anims = Array.from(containers).map((container) => lottie.loadAnimation({
        container,                       // DOM容器
        renderer: 'svg',                 // 渲染方式
        loop: true,                      // 是否循环
        autoplay: true,                  // 自动播放
        animationData: JSON.parse(JSON.stringify(animationData)) // lottie 会改写传入的数据，多实例需各自持有一份
      }))
    },

    checkIsReverse () {
      if (window.matchMedia('(orientation: portrait)').matches) {
        this.isReverse = true
      } else if (window.matchMedia('(orientation: landscape)').matches) {
        this.isReverse = false
      }
    },

    // requestBannerData () {
    //   const requestBody = {
    //     pn: this.pn,
    //     aid: this.aid,
    //     pkg: this.pkg,
    //     uid: this.uid,
    //     code: this.code,
    //     channel: this.channel
    //   }
    //   http.getHttp(`/landscape'/landscape/customizedCarousel/queryConfigure', JSON.stringify(requestBody)).then((reps) => {
    //     if (reps.code !== 0) {
    //       return
    //     }
    //     this.banner = reps.data.list
    //     this.autoplay = reps.autoplay
    //     this.$nextTick(() => {
    //       // eslint-disable-next-line no-new
    //       new Swiper('.banner-contain', {
    //         isReverse: this.isReverse,
    //         loop: true
    //       })
    //     })
    //   })
    // }
  }
}
</script>

<template>
  <div class="swiper-container banner-contain" ref="bannerRef">
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <div class="lottie-slide"></div>
      </div>
      <div class="swiper-slide">
        <img class="banner-image" src="@/assets/bg_banner2.jpg"/>
      </div>
    </div>
    <div class="swiper-pagination" ref="paginationRef"></div>
  </div>
</template>

<style scoped>

.banner-contain {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.swiper-slide {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lottie-slide {
  width: 100%;
  height: 100%;
}

/* 图比容器扁：按宽铺满、高度自适应并垂直居中，元素框刚好等于画面本身，
   圆角才能切在图上（object-fit: contain 只缩画面不缩元素框，圆角会落在空白处） */
.banner-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  display: block;
  border-radius: 1.6rem;
}

.swiper-pagination {
  position: absolute;
  left: 0;
  bottom: 1rem;
  width: 100%;
  text-align: center;
  z-index: 10;
}

.swiper-pagination :deep(.swiper-pagination-bullet) {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin: 0 0.5rem;
  border-radius: 50%;
  background: #ffffff;
  opacity: 0.4;
  cursor: pointer;
}

.swiper-pagination :deep(.swiper-pagination-bullet-active) {
  opacity: 1;
}
</style>
